import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv";
import React from "react";
import { IIconProps } from "./Icon/Interfaces";

const TableIcon = ({
  width = 21,
  height = 22,
  strokeColor = "var(--gray)",
}: IIconProps) => {
  return (
    <HyperDiv width={width} height={height} centeredY>
      <svg
        height="100%"
        width="100%"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="17"
          height="2"
          stroke={strokeColor}
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 6H0V24H19V6ZM6.33333 13H1.40741V17H6.33333V13ZM1.40741 18H6.33333V22H1.40741V18ZM6.33333 8H1.40741V12H6.33333V8ZM7.03704 13H11.963V17H7.03704V13ZM11.963 18H7.03704V22H11.963V18ZM7.03704 8H11.963V12H7.03704V8ZM17.5926 13H12.6667V17H17.5926V13ZM12.6667 18H17.5926V22H12.6667V18ZM17.5926 8H12.6667V12H17.5926V8Z"
          fill={strokeColor}
        />
      </svg>
    </HyperDiv>
  );
};

export default TableIcon;
